#import "../../../graphql/fragments/inbox-message-fragment.graphql"

mutation SendMessage($input: MessageSendInput!) {
    messageSend(input: $input) {
        message {
            ...InboxMessageFragment
        }
    }
}
